import { Helmet } from 'react-helmet-async';
import qwerteeBot from 'assets/qwerteeBot.png';
import { getDesignsImageUrl } from 'helpers/imageUrl';

const ogDefault = {
  title: 'Limited Edition Cheap Daily T Shirts',
  description:
    'We sell incredible t shirts for a limited time only (or until they sell out) for as little as the incredible price of £9/€11/$12',
  type: 'website',
  image: `${process.env.REACT_APP_BASE_URL}${qwerteeBot}`,
};

const generateStructuredData = ({
  product,
  productType,
  currencyCode,
  productPrice,
}) =>
  JSON.stringify({
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: product.name,
    description: `${product.name} ${productType} was designed by ${product.user.username}`,
    image: product.types.map((type) => getDesignsImageUrl(type.img, 255, 306)),
    brand: {
      '@type': 'Brand',
      name: 'Qwertee',
    },
    offers: {
      '@type': 'Offer',
      price: productPrice[currencyCode],
      priceCurrency: currencyCode,
      availability: 'https://schema.org/InStock',
    },
  });

export const Head = ({
  title = '',
  canonicalUrl = '',
  robotsNoIndex,
  og,
  structuredData,
}) => {
  const ogMerged = {
    ...ogDefault,
    ...og,
  };

  return (
    <Helmet>
      {/* Page title */}
      <title>{`Qwertee | ${title} Limited Edition Cheap Daily T Shirts`}</title>

      {/* Canonical URL */}
      <link
        rel="canonical"
        href={`${process.env.REACT_APP_BASE_URL}${canonicalUrl}`}
      />

      {/* Robots No Index meta tags */}
      {robotsNoIndex && <meta name="robots" content="noindex" />}

      {/* Open Graph meta tags */}
      <meta
        property="og:url"
        content={`${process.env.REACT_APP_BASE_URL}${canonicalUrl}`}
      />
      <meta property="og:type" content={ogMerged.type} />
      <meta property="og:title" content={ogMerged.title} />
      <meta property="og:description" content={ogMerged.description} />
      <meta property="og:image" content={ogMerged.image} />
      {structuredData && (
        <script type="application/ld+json">
          {generateStructuredData(structuredData)}
        </script>
      )}
    </Helmet>
  );
};
